import './Section.scss';

export default function Section({color, type, children}) {
    const sectionColor = color ? " section-" + color : "";
    const sectionType = type ? " section-" + type : "";

    return (
        <>
            <section className={ `${sectionColor} ${sectionType} `}>
                <div className="row center-xs section-content">
                    <div className="col-lg-12">
                        <div className="box">
                            <div className="row">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
  }